var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timers && _vm.timers.length)?_c('div',{staticClass:"text-gray-100 flex flex-wrap justify-center items-center"},_vm._l((_vm.timers),function(timer,index){return _c('TimerCard',{key:timer.id,staticClass:"m-1",attrs:{"timer":timer,"index":index},on:{"delete-timer":function($event){return _vm.$emit('delete-timer')}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }